(function () {
  'use strict';

  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function runCountUps(scope) {
    var els = [];
    if (scope.hasAttribute && scope.hasAttribute('data-pb-count')) els.push(scope);
    if (scope.querySelectorAll) {
      els = els.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-pb-count]')));
    }
    els.forEach(function (el) {
      if (el.getAttribute('data-pb-counted')) return;
      el.setAttribute('data-pb-counted', '1');
      var text = el.textContent;
      var match = text.match(/(\d[\d,]*)/);
      if (!match) return;
      var target = parseInt(match[1].replace(/,/g, ''), 10);
      if (!isFinite(target)) return;
      if (reduce.matches) return;
      var prefix = text.slice(0, match.index);
      var suffix = text.slice(match.index + match[1].length);
      var useGrouping = match[1].indexOf(',') !== -1;
      var start = null;
      var duration = 1200;
      function frame(ts) {
        if (start === null) start = ts;
        var k = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - k, 3);
        var value = Math.round(target * eased);
        el.textContent = prefix + (useGrouping ? value.toLocaleString('en-GB') : String(value)) + suffix;
        if (k < 1) requestAnimationFrame(frame);
      }
      el.textContent = prefix + '0' + suffix;
      requestAnimationFrame(frame);
    });
  }

  function initReveals() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('.pb-reveal, [data-pb-inview]'));
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-inview'); runCountUps(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        runCountUps(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce.matches) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-pb-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > vh + 120) return;
        var factor = parseFloat(el.getAttribute('data-pb-parallax'));
        if (!isFinite(factor)) factor = 0.08;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progress * factor * 100).toFixed(2) + 'px,0)';
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    initReveals();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
